import { useMutation, useQueryClient, type UseMutationOptions } from '@tanstack/react-query';
import { TOTP, totpAuthenticatorQueryKeys } from '#api';

type Args = Pick<UseMutationOptions<TOTP.DeleteAuthenticatorResult, unknown, string>, 'onSuccess' | 'onError'>;

export function useDeleteTOTPMutation({ onSuccess, onError }: Args = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (totpId: string) => TOTP.deleteAuthenticator(totpId),
    onSuccess: (data, totpId, context) => {
      queryClient.removeQueries({ queryKey: totpAuthenticatorQueryKeys.detail(totpId), exact: true });
      void queryClient.invalidateQueries({ queryKey: totpAuthenticatorQueryKeys.lists() });
      onSuccess?.(data, totpId, context);
    },
    onError,
  });
}
